import { Box, Text, Button, Flex } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Heading } from '@vibe/core';

type ConfirmModalProps = {
  isOpen: boolean;
  isConfirming: boolean;
  headline: string;
  text: string;
  info?: string;
  confirmButtonLabel?: string;
  onConfirm: () => Promise<any>;
  onClose: () => void;
};

export function ConfirmModal({
  isOpen,
  onConfirm,
  isConfirming,
  onClose,
  headline,
  text,
  info,
  confirmButtonLabel = 'Confirm',
}: ConfirmModalProps) {
  return (
    <AppModal
      show={isOpen}
      onClose={() => {
        onClose();
      }}
      contentSpacing={false}
      alertDialog={false}
      width={300}
    >
      <AppModalContent>
        <Box marginBottom="large">
          <Heading type="h3" weight="bold" align="start" style={{ marginBottom: '16px' }}>
            {headline}
          </Heading>
          <Text type="text2" weight="normal" align="start" color="primary">
            {text}
          </Text>
        </Box>
        <Box marginBottom="small">
          <Flex gap={16}>
            <Button
              size="medium"
              kind="primary"
              color="negative"
              loading={isConfirming}
              disabled={isConfirming}
              style={{
                width: '100%',
              }}
              onClick={async () => {
                onConfirm();
              }}
            >
              {confirmButtonLabel}
            </Button>
          </Flex>
          {info ? (
            <Box marginTop="medium">
              <Text type="text3" weight="normal" align="start" color="secondary" ellipsis={false}>
                {info}
              </Text>
            </Box>
          ) : null}
        </Box>
      </AppModalContent>
    </AppModal>
  );
}
